import React, { Component } from 'react'
import PropTypes from 'prop-types'
import emitter from '../../../utils/emitter'

export default class PageTitleBar extends Component {
  static propTypes = {
    content: PropTypes.string,
    onClick: PropTypes.func,
  }

  static defaultProps = {
    content: '',
    onClick: () => {},
  }

  constructor(props) {
    super(props)

    this.state = {
      hasDragHandle: window.$(window).width() < 800,
    }

    this.handleChangeSidebar = nextHasDragHandle => {
      this.setState({ hasDragHandle: nextHasDragHandle })
    }

    this.openSideBar = () => emitter.emit('SIDEBAR::OPEN')
  }

  componentDidMount() {
    emitter.on('SIDEBAR::CHANGE', this.handleChangeSidebar)
  }

  componentWillUnmount() {
    emitter.off('SIDEBAR::CHANGE')
  }

  render() {
    const { hasDragHandle } = this.state
    const { content, onClick } = this.props

    return (
      <div
        className="shadow"
        style={{
          display: 'flex',
          flex: 1,
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingLeft: '10px',
          paddingRight: '10px',
          height: '50px',
          backgroundColor: 'white',
        }}
      >
        {hasDragHandle && (
          <button className="btn btn-clear" onClick={this.openSideBar}>
            <i
              className="fal fa-bars"
              style={{ marginLeft: '10px', marginRight: '10px' }}
            />
          </button>
        )}
        <h4>{content}</h4>
        <i onClick={onClick} className="fal fa-question-circle" />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ui/navigation/PageTitleBar.js